export default function Django_Get_Started() {
  return <div>Django_Get_Started Component</div>;
}
